import React from 'react';
import './Pagination.css';

const Pagination = ({ currentPage, totalPages, onPageChange, totalItems }) => {
  const handleFirstPage = () => {
    onPageChange(1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handleLastPage = () => {
    onPageChange(totalPages);
  };

  const handlePageInput = (e) => {
    const page = parseInt(e.target.value);
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  return (
    <div className="pagination-container">
      <div className="pagination-controls">
        <button 
          className="pagination-btn first-btn" 
          onClick={handleFirstPage}
          disabled={currentPage === 1}
          title="First page"
        >
          ⏮
        </button>
        
        <button 
          className="pagination-btn prev-btn" 
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
          title="Previous page"
        >
          ◀
        </button>
        
        <div className="page-info">
          <input 
            type="number" 
            className="page-input"
            value={currentPage}
            onChange={handlePageInput}
            min="1"
            max={totalPages}
          />
        </div>
        
        <button 
          className="pagination-btn next-btn" 
          onClick={handleNextPage}
          disabled={currentPage === totalPages || totalPages === 0}
          title="Next page"
        >
          ▶
        </button>
        
        <button 
          className="pagination-btn last-btn" 
          onClick={handleLastPage}
          disabled={currentPage === totalPages || totalPages === 0}
          title="Last page"
        >
          ⏭
        </button>
      </div>
      
      <div className="pagination-info">
        {totalItems === 0 ? (
          <span>No items to display</span>
        ) : (
          <span>
            Page {currentPage} of {totalPages} ({totalItems} items total)
          </span>
        )}
      </div>
    </div>
  );
};

export default Pagination;
